export default {
  props: {
    contextType: {
      type: String,
      require: false,
      default: 'error',
    },
    messages: {
      type: Array,
      require: false,
      default: () => [],
    },
  },
  methods: {
    close() {
      store.dispatch('general/resetMessages');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/alert/alert.js